import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { Component, OnInit } from "@angular/core";
import { NacinPlacanja } from './nacin-placanja';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'yt-nacin-placanja-modal-update',
    templateUrl: './nacin-placanja-modal-update.component.html'
})

export class NacinPlacanjaModalUpdateComponent extends BaseModalUpdateComponent<NacinPlacanja> implements OnInit{
    constructor(
        protected modalContainerService: ModalContainerService<NacinPlacanja>,
        protected activeModal: NgbActiveModal,
        protected modalService: ModalService
    ){
        super(modalContainerService, activeModal,modalService);
    }

    ngOnInit(){
        
    }
}